[
   {
      "text": "Music",
      "value": 1
   },
   {
      "text": "Dance",
      "value": 2
   },
   {
      "text": "Drama",
      "value": 3
   }
]
